
<fc-content-header-summary [content]="content" [analyticsMode]="analyticsMode">
    <ul>
        <li *ngFor="let c of content.components; index as i;">
            <h3>{{c.heading}}</h3>
            <span [innerHtml]="c.content | marked: analyticsMode"></span>
        </li>
    </ul>
</fc-content-header-summary>
